import * as COMMON from "../files/errors/commonErrors.i18n";
import * as VALIDATOR from "../files/errors/validatorErrors.i18n";

export const common = COMMON;
export const validator = VALIDATOR;